import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'

import LoyaltyStatus from 'lmcv/modules/LoyaltyStatus'

import { navigationWrapperStyles, itemStyles, itemActiveStyles } from './styles'

const NavigationWrapper = styled('nav')(navigationWrapperStyles)
const Item = styled(Link, {
  shouldForwardProp: prop => isPropValid(prop)
})(itemStyles, itemActiveStyles)

function Navigation ({ history, status }) {
  const loyaltyProRelationship =
    localStorage.getItem('@loyalty:proRelationship') === 'true'
  const loyaltyStatus = LoyaltyStatus(status)

  const proLink =
    loyaltyStatus.isProEAD() && loyaltyProRelationship
      ? [
          {
            name: 'Clientes',
            path: '/clientes'
          }
        ]
      : []

  const LINKS = [
    {
      name: 'Início',
      path: '/'
    },
    {
      name: 'Vantagens',
      path: '/minhas-vantagens'
    },
    {
      name: 'Troque',
      path: '/troque'
    },
    {
      name: 'Pontos',
      path: loyaltyStatus.is(7) ? '/pro-meus-pontos' : '/meus-pontos'
    },
    ...proLink,
    {
      name: 'Dúvidas',
      path: '/duvidas'
    }
  ]

  return (
    <NavigationWrapper>
      {LINKS.map(({ name, path }) => (
        <Item
          key={name}
          to={path}
          active={history.location.pathname === path}
        >
          {name}
        </Item>
      ))}
    </NavigationWrapper>
  )
}

Navigation.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string
    })
  }).isRequired,
  status: PropTypes.number.isRequired
}

export default Navigation
